import { FC } from 'react';
import styles from './index.module.less';
import { IFarRedData } from '@pro/linearTopLight/interface';
import { ModuleHeader } from '@app/linearTopLight/ModuleHeader';
import { ProdOverlayBanner } from '@app/linearTopLight/ProdOverlayBanner';
import { HtmlRender } from '@base/snippets/HtmlRender';
import { GridRender } from '@base/snippets/GridRender';
import Image from '@base/lib/ThemeImage';
import cn from 'classnames';

type IFarRedProps = {
    data: IFarRedData;
};

export const FarRed: FC<IFarRedProps> = props => {
    const { data } = props;
    const { note } = data;

    return (
        <ProdOverlayBanner data={data} className={styles['far-red']}>
            <ModuleHeader
                className={styles.header}
                title={data.title}
                description={data.description}
                center
            />
            <div className={styles.note}>
                <HtmlRender className={cn(styles['note-title'], 'text-center g-font-ext-bold')} html={note.title}/>
                <GridRender
                    colsPerRow={2}
                    gutter={64}
                    list={note.list}
                    render={item => (
                        <div className={'flex'}>
                            <Image
                                src={item.icon}
                                width={38}
                                fixed
                                background={false}
                                pure
                            />
                            <div className={cn(styles['item-text'], 'flex-1')}>
                                <HtmlRender className={styles['item-title']} html={item.title}/>
                                <HtmlRender className={cn(styles['item-desc'], 'g-font-ext-light')} html={item.description}/>
                            </div>
                        </div>
                    )}
                />
            </div>
        </ProdOverlayBanner>
    )
};
